const SESSION_EXPIRED_NOTICE_KEY = 'apex:session-expired'
let handlingSessionExpiry = false

export function beginSessionExpiry(): boolean {
  if (handlingSessionExpiry) return false

  handlingSessionExpiry = true
  localStorage.removeItem('role')
  localStorage.removeItem('displayName')
  localStorage.removeItem('token')
  sessionStorage.setItem(SESSION_EXPIRED_NOTICE_KEY, '1')

  const isLoginRoute = window.location.pathname === '/login' || window.location.pathname === '/login/'
  if (!isLoginRoute) {
    window.location.replace('/login')
  }
  return true
}

export function resetSessionExpiry(): void {
  handlingSessionExpiry = false
  sessionStorage.removeItem(SESSION_EXPIRED_NOTICE_KEY)
}

export function consumeSessionExpiredNotice(): boolean {
  const shouldNotify = sessionStorage.getItem(SESSION_EXPIRED_NOTICE_KEY) === '1'
  sessionStorage.removeItem(SESSION_EXPIRED_NOTICE_KEY)
  return shouldNotify
}
